import React from "react";
import SocialLinks from "./SocialLinks";

function Footer() {
  return (
    <section className="footer">
      <div className="container">
        <p>Copyright {new Date().getFullYear()}. All Rights Reserved.</p>
        <small>"Icon made by Pixel perfect from www.flaticon.com"</small>
        <SocialLinks />
      </div>
    </section>
  );
}

export default Footer;
